import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What exactly is Vaymilo?",
    a: "Vaymilo is a small digital product studio. We make AI kits, templates, and workflows you can use right away — no learning curve, no fluff.",
  },
  {
    q: "Who are these tools for?",
    a: "Students, creators, freelancers, and modern teams who want clean systems for everyday writing, planning, and content work.",
  },
  {
    q: "How do I get my files after purchasing?",
    a: "You'll get an instant digital download. Files are delivered as clean, copy-ready documents — no app required.",
  },
  {
    q: "Do I need to know AI to use the kits?",
    a: "No. Every kit includes a short, beginner-friendly guide and ready-to-use prompts. If you can copy and paste, you can use it.",
  },
  {
    q: "Is there a membership?",
    a: "Yes — Studio ($12/mo) unlocks the entire library, every monthly drop, and higher Playground limits. Founder ($29/mo) adds source files, beta access, and a direct line to the team. You can also buy any kit individually.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. Cancel a membership any time from your account — you keep access until the end of your current billing period.",
  },
  {
    q: "Can I share or resell the kits?",
    a: "Single-user license. You can use the kits for your own work and client deliverables, but please don't resell or redistribute the raw files.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="bg-white border-y border-[#E7E7E2]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="overline">— FAQ</div>
            <h2 className="mt-5 font-sora text-[36px] sm:text-[44px] lg:text-[52px] font-bold text-[#111111] tracking-tight leading-[1.05]">
              Questions,
              <br />
              answered.
            </h2>
            <p className="mt-6 font-manrope text-[15px] text-[#111111]/65 leading-relaxed max-w-sm">
              Still not sure? Send a note from the contact section below — we
              reply personally.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, idx) => (
                <AccordionItem
                  key={item.q}
                  value={`faq-${idx}`}
                  className="border-b border-[#E7E7E2]"
                  data-testid={`faq-item-${idx}`}
                >
                  <AccordionTrigger className="py-6 font-sora text-[18px] md:text-[20px] font-semibold text-[#111111] hover:no-underline text-left">
                    <span className="flex items-baseline gap-5">
                      <span className="font-mono text-xs text-[#111111]/40">
                        0{idx + 1}
                      </span>
                      <span>{item.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-10 font-manrope text-[15px] md:text-[16px] text-[#111111]/70 leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
